import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './LegalPages.css';

const TermsAndConditionsPage = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      {/* Navbar */}
      <nav className="legal-navbar">
        <div className="legal-navbar-container">
          <Link to="/" className="legal-logo-link">
            <img
              src="/logo512.png"
              alt="Reveel Logo"
              className="legal-logo-image"
            />
          </Link>
          <Link to="/" className="legal-back-nav">
            {t('legal.backToHome')}
          </Link>
        </div>
      </nav>

      <div className="legal-content">
        <h1 className="legal-title">{t('termsAndConditions.title')}</h1>
        <div className="legal-prose">
          <p>{t('termsAndConditions.intro1')}</p>
          <p>{t('termsAndConditions.intro2')}</p>
          <p>{t('termsAndConditions.intro3')}</p>

          <h2>{t('termsAndConditions.healthDisclaimer.title')}</h2>
          <p>{t('termsAndConditions.healthDisclaimer.p1')}</p>
          <p>{t('termsAndConditions.healthDisclaimer.p2')}</p>

          <p>{t('termsAndConditions.thirdParty.p1')}</p>
          <p>{t('termsAndConditions.thirdParty.p2')}</p>
          <ul>
            <li><a href="https://supabase.com/terms" target="_blank" rel="noopener noreferrer">Supabase</a></li>
            <li><a href="https://www.apple.com/legal/internet-services/itunes/" target="_blank" rel="noopener noreferrer">Apple Services</a></li>
          </ul>

          <p>{t('termsAndConditions.responsibility.p1')}</p>
          <p>{t('termsAndConditions.responsibility.p2')}</p>
          <p>{t('termsAndConditions.responsibility.p3')}</p>
          <p>{t('termsAndConditions.responsibility.p4')}</p>

          <h2>{t('termsAndConditions.userContent.title')}</h2>
          <p>{t('termsAndConditions.userContent.p1')}</p>
          <p>{t('termsAndConditions.userContent.p2')}</p>

          <h2>{t('termsAndConditions.changes.title')}</h2>
          <p>{t('termsAndConditions.changes.p1')}</p>
          <p>{t('legal.effectiveDate')}</p>

          <h2>{t('termsAndConditions.contact.title')}</h2>
          <p>
            {t('termsAndConditions.contact.p1')}{' '}
            <a href="mailto:hello@reveel.health">hello@reveel.health</a>.
          </p>
        </div>
        <Link to="/" className="legal-back-link">
          ← {t('legal.backToHome')}
        </Link>
      </div>

      {/* Footer */}
      <footer className="legal-footer">
        <div className="legal-footer-container">
          <div className="legal-footer-logo">
            <img
              src="/logo512.png"
              alt="Reveel Logo"
            />
            <span>Reveel</span>
          </div>
          <div className="legal-footer-center">
            <Link to="/privacy-policy" className="legal-footer-link">{t('footer.privacy')}</Link>
            <Link to="/terms-and-conditions" className="legal-footer-link">{t('footer.terms')}</Link>
          </div>
          <p className="legal-footer-text">
            {t('footer.copyright')}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TermsAndConditionsPage;
